import operationReportService from "@/services/operations/operationReportService";
import mapKeys from "lodash/mapKeys.js";

// NOTE: マスタデータではない。レポート一覧のデータを管理する
const INITIAL_STATE = {
  // 一覧に表示するデータ
  operationReports: {
    ao_enterprise_vessel_reports: [
      // {
      //   "ao_enterprise_vessel_report_form_versions": [
      //     {
      //       "ao_enterprise_vessel_report_form_version_items": [
      //         {
      //           "ao_enterprise_vessel_report_form_version_id": "string",
      //           "form_version_item_id": "string",
      //           "id": "string",
      //           "value_date": "string",
      //           "value_date_time": "2024-03-22T11:46:36.817Z",
      //           "value_number": 0,
      //           "value_string": "string",
      //           "value_time": "string"
      //         }
      //       ],
      //       "form_version_id": "string",
      //       "id": "string"
      //     }
      //   ],
      //   "ao_enterprise_workflow_vessel_id": "string",
      //   "created_at": "2024-03-22T11:46:36.817Z",
      //   "hash": "string",
      //   "id": "string",
      //   "updated_at": "2024-03-22T11:46:36.817Z",
      //   "version": 0,
      //   "workflow_status_id": "string"
      // }
    ],
    page: 0,
    total_pages: 0,
    total_elements: 0,
  }, // : AoEnterpriseVesselReportRootList
};

export default {
  isRegistered: false,
  namespaced: true,

  state: {
    ...INITIAL_STATE,
  },

  mutations: {
    SET_OPERATION_REPORTS(state, data) {
      state.operationReports = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },

  actions: {
    /**
     * operation reportsをstoreにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     * @throws {Error}
     */

    async setOperationReports({ commit }, payload) {
      const queryParameters = operationReportService.operationReportIndexRequestObject(
        payload
      );
      const operationReports = await operationReportService.getOperationReports(
        queryParameters
      );
      await operationReportService.setReportSearchConditions(queryParameters); // 検索条件保存
      commit("SET_OPERATION_REPORTS", operationReports.data || {});
    },

    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },

  getters: {
    validEnterpriseVesselReports: ({ operationReports }) => {
      return operationReportService.validEnterpriseVesselReports(
        operationReports
      );
    },
    formVersionItemMapOfReportIdToFormVersionItemId: (
      _,
      { validEnterpriseVesselReports }
    ) => {
      return validEnterpriseVesselReports.reduce((acc, report) => {
        acc[report.id] = mapKeys(
          report.ao_enterprise_vessel_report_form_versions
            .map(rfv => rfv.ao_enterprise_vessel_report_form_version_items)
            .flat(),
          "form_version_item_id"
        );

        return acc;
      }, {});
    },
    page: ({ operationReports }) => {
      return operationReportService.page(operationReports);
    },
    totalPages: ({ operationReports }) => {
      return operationReportService.totalPage(operationReports);
    },
    totalElements: ({ operationReports }) => {
      return operationReportService.totalElements(operationReports);
    },
  },
};
